import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Workspace } from '../../models/workspace';
import { withWorkspaceSelectors } from './workspace.selectors';
import { WorkspaceService } from '../../services/workspace.service';
import { withLogging } from '../features/logger.feature';

export type WorkspaceState = BaseState<Workspace>;

export const initialState: WorkspaceState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  selectedId: '',
  selection: [],
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Workspace',
  entityLabel: 'Arbeitsbereich',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
  events: {
    add: ['writeWorkspaceToEntities'],
    update: ['writeWorkspaceToEntities'],
  },
};

export const WorkspaceStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Workspace>(WorkspaceService),
  withLogging(initialState.entityType),
  withWorkspaceSelectors(),
  withMethods(store => ({})),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
